// @flow

export const HOVERED_CLASS = 'data-table__row_hovered';

export const TableSize = {
    M: 'M',
    DEFAULT: 'DEFAULT'
};

export type TableSizeType = $Keys<typeof TableSize>;

export const DataTableRowSize = {
    M: 31,
    DEFAULT: 24
};

export const HighlightType = {
    NONE: 'NONE',
    SUGGEST: 'SUGGEST',
    INACTIVE: 'INACTIVE'
};

export const tableCellName = 'data-table__cell';
export const headerCellName = 'data-table__cell_header-cell';

export const tableRowName = 'data-table__row';
export const virtualizedCellsArea = 'data-table__virtualized-cells-area';
export const treeRowsBodyName = 'data-table__tbody_tree';
export const dataTableEventsDisabled = 'data-table-disable-pointer-events';
export const withoutDataTableShadow = 'without-data-table-shadow';
export const MAIN_COLUMN_ID = 'main';
export const MIN_WIDTH = 0;

export const HORIZONTAL_SCROLL_DELTA = 90;

export const tableElements = {
    frozenHeader: '.data-table__headers_freeze',
    body: '.data-table__tbody'
};

export const tableHeaderModificators = {
    rightHeaders: 'data-table__headers-container_right',
    leftHeaders: 'data-table__headers-container_left',
    fixedHeaders: 'data-table__headers-container_fixed',
    pinnedHeaders: 'data-table__headers-container_pinned',
};

export const handleClass = 'data-table__resizable-handle';
export const handleClassResize = 'data-table__resizable-handle_resize';
export const SCROLL_DIRECTION = {
    up: 'SCROLL_UP',
    down: 'SCROLL_DOWN'
};

export const DefaultVirtualizeHorizontalData = {
    cellStartIndex: 0,
    cellEndIndex: 0,
    leftOffset: 0,
    rightOffset: 0,
    isVirtualizedCells: false,
    renderCellPlaceholder: false
};

export const TIMER_DELAY = 150;

export const TABLE_PARTS = {
    left: 'left',
    right: 'right'
};

export const TOGGLE_CLASS_ACTIONS = {
    add: 'ADD',
    remove: 'REMOVE'
};

export const ON_RESIZE_CLASSNAME = 'on-resize';

export const CLASS_PROPERTIES = {
    fixed: 'fixed',
    pinned: 'pinned',
    topTable: 'top-table'
};
